import {
  CaretDownOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  AutoComplete,
  Button,
  Divider,
  Dropdown,
  Input,
  Menu,
  Select,
  Space,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { selectToken } from "../app/features/authen";
import APIService from "../services/APIService";
import { getMarkSearch, queryParams, showMarkSearch } from "../utils";
import CategoryItem from "./items/CategoryItem";
const { Option } = Select;

const selectType = [
  { name: "Sản phẩm", value: 1 },
  { name: "Đại lý", value: 2 },
];

const SearchBar = () => {
  const [suggest, setSuggest] = useState({
    suggestText: [],
    suggestDrugMaster: [],
  });
  const ref = useRef(null);
  const selectTypeRef = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const selectRef = useRef(null);
  const autoCompleteRef = useRef(null);
  const [dataSearch, setDataSearch] = useState([]);
  const [stringSearch, setStringSearch] = useState();
  const [valueType, setValueType] = useState("1");
  const [width, setWidth] = useState(660);
  const navigate = useNavigate();
  const searchParam = searchParams.get("search");
  const token = useSelector(selectToken);

  const ProductItem = (item) => {
    return (
      <Link
        to={`/product-details?drugId=${item.drug_id}`}
        onClick={() => {
          selectRef.blur();
        }}
      >
        <div className="flex flex-row sm:h-[60px] h-[45px] bg-[#F3F3F3] items-center p-2 sm:rounded-2xl rounded-md">
          <img alt="" src={item.image} className="w-[30px] object-contain" />
          <p className="ml-2 text-xs text-two-lines sm:text-sm">
            {item.drug_name}
          </p>
        </div>
      </Link>
    );
  };

  async function getSearchSuggest() {
    const RESULT = await APIService.getSearchSuggest();
    if (RESULT) {
      setSuggest(RESULT);
    }
  }
  useEffect(() => {
    getSearchSuggest();
  }, []);

  async function getSearchProduct(search) {
    const RESULT = await APIService.drugSearchSuggestion(search);
    if (RESULT) {
      setDataSearch(RESULT);
    }
  }

  async function getAgentsList(search) {
    const RESULT = await APIService.getAgentsList(search);
    if (RESULT) {
      setDataSearch(RESULT.data);
    }
  }

  useEffect(() => {
    if (stringSearch?.length > 0) {
      if (valueType === "1") {
        getSearchProduct(stringSearch);
      } else {
        getAgentsList(stringSearch);
      }
      if (stringSearch?.length == 1) {
        autoCompleteRef.current.focus();
      }
    } else if (dataSearch.length > 0 && getMarkSearch()) {
      selectRef.current.focus();
    }
  }, [stringSearch, valueType]);

  const onSelect = (newValue) => {
    setTimeout(() => {
      autoCompleteRef.current && autoCompleteRef.current.blur();
      selectRef.current && selectRef.current.blur();
    }, 200);
    const idProduct = newValue.slice(newValue.indexOf("&&") + 2);
    const nameProduct = newValue.slice(0, newValue.indexOf("&&"));
    setStringSearch(nameProduct);

    if (valueType == "1") {
      navigate(`/product-details?drugId=${idProduct}&search=${nameProduct}`);
    } else {
      navigate(`/agency-details?agencyId=${idProduct}&search=${nameProduct}`);
    }
  };

  const handleSearch = (newValue) => {
    setStringSearch(newValue);
  };

  useEffect(() => {
    setStringSearch(searchParam);
  }, [searchParam]);

  useEffect(() => {
    setTimeout(() => {
      setWidth(ref.current.offsetWidth);
    }, 300);
  }, [token]);

  return (
    <div
      className="relative flex items-center flex-1 w-full text-base font-medium rounded bg-gray"
      ref={ref}
    >
      <div className="flex flex-1 w-full py-1 overflow-hidden input-search">
        {stringSearch?.length ? (
          <AutoComplete
            ref={autoCompleteRef}
            style={{ width: "120%" }}
            dropdownMatchSelectWidth={width}
            onFocus={() => {
              showMarkSearch(true);
            }}
            onBlur={() => {
              showMarkSearch(false);
            }}
            className='search-bar'
            virtual={false}
            value={stringSearch}
            onChange={handleSearch}
            defaultActiveFirstOption={false}
            options={dataSearch.map((item) => {
              var obj;
              if (valueType == "1") {
                obj = {
                  label: item.name,
                  value: item.name + "&&" + item.drug_id,
                };
              } else {
                obj = { label: item.name, value: item.name + "&&" + item.id };
              }
              return obj;
            })}
            onSelect={onSelect}
            showAction={["focus"]}
          >
            <Input
              bordered={false}
              size="large"
              placeholder="input here"
              onPressEnter={(e) => {
                e.preventDefault();
                e.stopPropagation();
                autoCompleteRef.current && autoCompleteRef.current.blur();
                showMarkSearch(false);
                if (valueType == "1") {
                  navigate(`/search?search=${stringSearch}&cateId=0`);
                } else {
                  navigate(`/agency?search=${stringSearch}`);
                }
              }}
            />
          </AutoComplete>
        ) : (
          <Select
            ref={selectRef}
            dropdownMatchSelectWidth={width}
            dropdownStyle={{ padding: 12 }}
            showArrow={false}
            size="large"
            showSearch
            onFocus={() => {
              showMarkSearch(true);
            }}
            onBlur={() => {
              showMarkSearch(false);
            }}
            className="w-full search-bar"
            bordered={false}
            showAction={["focus", "click"]}
            onSelect={(value) => {
              setStringSearch(value);
            }}
            onSearch={handleSearch}
            placeholder="Tìm kiếm"
            dropdownRender={(menu) => (
              <>
                {suggest.suggestText.length > 0 ? (
                  <>
                    <p className="mb-2 text-sm font-bold sm:text-base">
                      Tìm kiếm gần đây
                    </p>
                    {menu}
                  </>
                ) : (
                  ""
                )}
                <p className="my-2 text-sm font-bold sm:text-base">
                  Tìm kiếm phổ biến
                </p>
                <div className="grid sm:grid-cols-3 grid-cols-2 gap-[10px]">
                  {suggest.suggestDrug?.map(ProductItem)}
                </div>
                <p className="my-2 text-sm font-bold sm:text-base">
                  Danh mục nổi bật
                </p>
                <div className="grid grid-cols-2 gap-[10px]">
                  {suggest.suggestCategory?.map((item) => (
                    <CategoryItem
                      onClick={() => {
                        selectRef.blur();
                      }}
                      data={item}
                    />
                  ))}
                </div>
              </>
            )}
          >
            {suggest.suggestText.map((item, index) => (
              <Option key={item}>{item}</Option>
            ))}
          </Select>
        )}
      </div>
      <SearchOutlined className="absolute text-[#119AE2] w-4 h-4 top-4 right-[150px]" />
      <Divider type="vertical" />
      <Select
        ref={selectTypeRef}
        style={{ width: 130 }}
        size="large"
        value={valueType}
        bordered={false}
        onSelect={(value) => {
          setValueType(value);
          setDataSearch([]);
          console.log(valueType);
        }}
        suffixIcon={<CaretDownOutlined className={"ant-select-suffix"} />}
      >
        {selectType.map((item, index) => (
          <Option key={item.value}>{item.name}</Option>
        ))}
      </Select>
    </div>
  );
};

export default SearchBar;
